import React, { useState, useEffect, useContext } from "react";
import ReactApexChart from "react-apexcharts";
import CountUp from "react-countup";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import {
  getNoOfEmployee,
  countLateAttendence_and_Leaves,
  findEmployeeByUserId,
  // getLateAttendence,
  getAttendanceCountByBranchCount,
  getMonthlyAttendanceByBranch,
  getThisWeekBirthdays,
  getTodayLeaves,
  getProbationEndEmployees
} from "../../service/dashboardSerice";
import { getAllBusinessSettings } from "../../service/businessSettingsService";
import { all_routes } from "../../Router/all_routes";

import { getUserById } from "../../service/userService";
import { Menu } from "react-feather";
// import ProPic from "../../assets/users/PIC.png";
import { UserContext } from "../../context/userContext";
import dayjs from "dayjs";
import { base_path_img } from "../../environment.jsx";

const Dashboard = () => {
  const navigate = useNavigate();
  const [rightPanelVisible, setRightPanelVisible] = useState(
    window.innerWidth > 768
  );
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedMonth, setSelectedMonth] = useState("");
  const [daysInMonth, setDaysInMonth] = useState(0);
  const [firstDayOfMonth, setFirstDayOfMonth] = useState(0);
  const [selectedBranch, setSelectedBranch] = useState();
  const [loading, setLoading] = useState(false);
  const [currentTime, setCurrentTime] = useState("");
  const [thisWeekBirthdays, setThisWeekBirthdays] = useState([]);
  const [todayLeaves, setTodayLeaves] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  // const [profileImageUrl,
  //   // setProfileImageUrl
  // ] = useState(ProPic);
  // const [userData, setUserData] = useState({ name: 'Eleanor' });
  const [noOfEmployee, setNoOfEmployee] = useState([]);
  const [todayLeaveCount, setTodayLeaveCount] = useState(0);
  const [todayAttendanceCount, setTodayAttendanceCount] = useState(0);
  // const [attendencePerBranch, setAttendencePerBranch] = useState(0);
  const [probationEndEmployees, setProbationEndEmployees] = useState([]);

  const { user } = useContext(UserContext);
  const [countLate, setCountLate] = useState(0);

  const [nextPayDate, setNextPayDate] = useState("—");
  const [daysRemaining, setDaysRemaining] = useState(null);

  const [startDateFromRange, setStartDateFromRange] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [endDateFromRange, setEndDateFromRange] = useState(
    dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [userDetail, setUserDetail] = useState(null);

  const storedUser = localStorage.getItem("user");
  const role = storedUser ? JSON.parse(storedUser)?.data?.role?.roleName : null;
  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const branchOptions = [
    { value: "wattala", label: "Wattala" },
    { value: "negombo", label: "Negombo" },
    { value: "kaduwela", label: "Kaduwela" },
    { value: "kiribathgoda", label: "Kiribathgoda" },
    { value: "kandana", label: "Kandana" },
    { value: "delgoda", label: "Delgoda" },
    { value: "okids", label: "OKIDS-Wattala" },
    { value: "okit", label: "OKIT-Wattala" },
    { value: "lsu", label: "Wattala LSU" },
    { value: "cityschool", label: "City School - Negombo" }


  ];


  // const currentMonth = dayjs().month() + 1;

  // Helper function to safely display employee name
  const safeDisplayName = (name) => {
    if (!name || name.trim() === '' || name.includes('undefined')) {
      return '—';
    }
    return name.trim();
  };

  const toggleRightPanel = () => {
    setRightPanelVisible(!rightPanelVisible);
  };

  // const [error, setError] = useState(null);

  // const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBusinessSettings = async () => {
      try {
        const response = await getAllBusinessSettings();
        console.log("Business Settings API Response:", response);

        // Handle { success: true, data: [...] } structure
        let settings;
        if (response.data && Array.isArray(response.data)) {
          settings = response.data[0];
        } else if (Array.isArray(response)) {
          settings = response[0];
        } else {
          settings = response;
        }

        console.log("Parsed Settings:", settings);

        if (settings && settings.salaryPeriod && settings.salaryPeriod.endDate) {
          const payDay = settings.salaryPeriod.endDate;
          const today = new Date();
          const currentYear = today.getFullYear();
          const currentMonth = today.getMonth(); // 0-indexed
          const currentDay = today.getDate();

          let payDate = new Date(currentYear, currentMonth, payDay);

          // If today is past the pay day, next pay date is next month
          if (currentDay > payDay) {
            payDate = new Date(currentYear, currentMonth + 1, payDay);
          }



          // Format date as YYYY-MM-DD
          setNextPayDate(dayjs(payDate).format("YYYY-MM-DD"));

          // Calculate days remaining
          const diffTime = Math.abs(payDate - today);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          setDaysRemaining(diffDays);
        } else {
          // Fallback if no settings found - Default to 20th as per requirements
          const today = new Date();
          const currentYear = today.getFullYear();
          const currentMonth = today.getMonth();
          const payDay = 20;

          let payDate = new Date(currentYear, currentMonth, payDay);

          if (today.getDate() > payDay) {
            payDate = new Date(currentYear, currentMonth + 1, payDay);
          }
          setNextPayDate(dayjs(payDate).format("YYYY-MM-DD"));

          // Calculate days remaining
          const diffTime = Math.abs(payDate - today);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          setDaysRemaining(diffDays);
        }
      } catch (error) {
        console.error("Error fetching business settings:", error);
        // Fallback on error - Default to 20th
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth();
        const payDay = 20;

        let payDate = new Date(currentYear, currentMonth, payDay);

        if (today.getDate() > payDay) {
          payDate = new Date(currentYear, currentMonth + 1, payDay);
        }
        setNextPayDate(dayjs(payDate).format("YYYY-MM-DD"));

        // Calculate days remaining
        const diffTime = Math.abs(payDate - today);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        setDaysRemaining(diffDays);
      }
    };

    fetchBusinessSettings();
  }, []);
  const getCurrentTime = () => {
    const now = new Date();
    const formattedTime = now.toLocaleTimeString();
    setCurrentTime(formattedTime);
  };

  useEffect(() => {
    const interval = setInterval(getCurrentTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const updateCalendar = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    setSelectedMonth(`${monthNames[month]} ${year}`);
    setDaysInMonth(new Date(year, month + 1, 0).getDate());
    setFirstDayOfMonth(new Date(year, month, 1).getDay());
  };

  const handleApply = (event, picker) => {
    const formattedStartDate = picker.startDate.format("YYYY-MM-DD");
    const formattedEndDate = picker.endDate.format("YYYY-MM-DD");

    setStartDateFromRange(formattedStartDate);
    setEndDateFromRange(formattedEndDate);

    // Update currentDate to reflect the selected range
    const newDate = picker.startDate.toDate();
    setCurrentDate(newDate);
    updateCalendar(newDate);

    NoOfLeaveCountBydateandCountLate(
      formattedStartDate,
      formattedEndDate,
      selectedBranch
    );
    fetchAttendanceCount(selectedBranch, formattedStartDate, formattedEndDate);
  };

  const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);
  const userObj = userData?.data;

  // useEffect(() => {
  //   const fetchProfilePicture = async () => {
  //     if (user?.id) {
  //       const imageUrl = await fetchUserProfilePicture(user.id);
  //       if (imageUrl) {
  //         setProfileImageUrl(imageUrl);
  //       }
  //     }
  //   };

  //   fetchProfilePicture(); // Call the function
  // }, [user?.id]);

  const handlePrevMonth = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() - 1);
    setCurrentDate(newDate);
    updateCalendar(newDate);

    // Update the date range to the previous month
    const prevMonthStart = dayjs(newDate).startOf("month").format("YYYY-MM-DD");
    const prevMonthEnd = dayjs(newDate).endOf("month").format("YYYY-MM-DD");
    setStartDateFromRange(prevMonthStart);
    setEndDateFromRange(prevMonthEnd);

    // Refresh data for the new month
    NoOfLeaveCountBydateandCountLate(
      prevMonthStart,
      prevMonthEnd,
      selectedBranch
    );
    fetchAttendanceCount(selectedBranch, prevMonthStart, prevMonthEnd);
  };

  const handleNextMonth = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + 1);
    setCurrentDate(newDate);
    updateCalendar(newDate);

    // Update the date range to the next month
    const nextMonthStart = dayjs(newDate).startOf("month").format("YYYY-MM-DD");
    const nextMonthEnd = dayjs(newDate).endOf("month").format("YYYY-MM-DD");
    setStartDateFromRange(nextMonthStart);
    setEndDateFromRange(nextMonthEnd);

    // Refresh data for the new month
    NoOfLeaveCountBydateandCountLate(
      nextMonthStart,
      nextMonthEnd,
      selectedBranch
    );
    fetchAttendanceCount(selectedBranch, nextMonthStart, nextMonthEnd);
  };

  useEffect(() => {
    updateCalendar(currentDate);

    const handleResize = () => {
      if (window.innerWidth > 768) {
        setRightPanelVisible(true);
      } else {
        setRightPanelVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchTodayData = async (branch = null) => {
    try {
      setLoading(true);
      const [birthdayResponse, leaveResponse, probationResponse] = await Promise.all([
        getThisWeekBirthdays(branch),
        getTodayLeaves(branch),
        getProbationEndEmployees(branch),
      ]);
      setThisWeekBirthdays(birthdayResponse.data || []);
      setTodayLeaves(leaveResponse.data || []);
      setProbationEndEmployees(probationResponse.data || []);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setThisWeekBirthdays([]);
      setTodayLeaves([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userObj && userObj._id) {
      const fetchUserData = async () => {
        try {
          const data = await getUserById(userObj._id);
          console.log("Fetched User Data:", data.data);

          console.log("Fetched User Data:", user.data);
          setUserDetail(data.data);
        } catch (err) {
          console.log(err);
        } finally {
          setLoading(false);
        }
      };
      fetchUserData();
    }
  }, []);

  // Initial data load on component mount - fetch employee's branch and load data
  useEffect(() => {
    const initializeDashboard = async () => {
      try {
        console.log("Initializing dashboard with employee's branch...");
        // Fetch employee's branch
        const countResponse = await findEmployeeByUserId();
        const employeeBranch = countResponse.data;
        console.log("===== EMPLOYEE BRANCH FROM API =====");
        console.log("Raw employee branch value:", employeeBranch);

        // Normalize branch: extract location name from formats like "OKI - Wattala", "OKIDS-Wattala", etc.
        let normalizedBranch = employeeBranch;
        if (employeeBranch && typeof employeeBranch === 'string') {
          // Remove prefixes like "OKI -", "OKIDS-", "OKIT-", etc. and get just the location
          const match = employeeBranch.match(/(?:OKI(?:DS|T)?\s*-\s*)?(.+)/i);
          if (match && match[1]) {
            normalizedBranch = match[1].trim().toLowerCase();
          } else {
            normalizedBranch = employeeBranch.trim().toLowerCase();
          }
        }

        console.log("Normalized branch value:", normalizedBranch);
        console.log("=====================================");

        if (normalizedBranch) {
          // Set the normalized branch as default
          setSelectedBranch(normalizedBranch);
          console.log("Loading data for branch:", normalizedBranch);

          // Load initial data with normalized branch
          await Promise.all([
            getNoOfEmployee_onTodate(normalizedBranch),
            fetchTodayData(normalizedBranch),
            fetchTodayLeaveCount(normalizedBranch),
            fetchTodayAttendanceCount(normalizedBranch),
            fetchAttendanceCount(normalizedBranch, startDateFromRange, endDateFromRange),
            NoOfLeaveCountBydateandCountLate(startDateFromRange, endDateFromRange, normalizedBranch)
          ]);

          console.log("Initial dashboard data loaded successfully");
          // Mark initial load as complete
          setIsInitialLoad(false);
        } else {
          console.warn("No employee branch found");
          setIsInitialLoad(false);
        }
      } catch (error) {
        console.error("Error initializing dashboard:", error);
        setIsInitialLoad(false);
      }
    };

    initializeDashboard();
  }, []);

  useEffect(() => {
    // Only make API calls if we have a valid branch selection AND it's not the initial load
    if (selectedBranch !== undefined && selectedBranch !== null && !isInitialLoad) {
      console.log("Branch changed to:", selectedBranch);
      fetchTodayData(selectedBranch);
      fetchTodayLeaveCount(selectedBranch);
      fetchTodayAttendanceCount(selectedBranch);
      fetchAttendanceCount(
        selectedBranch,
        startDateFromRange,
        endDateFromRange
      );
      NoOfLeaveCountBydateandCountLate(
        startDateFromRange,
        endDateFromRange,
        selectedBranch
      );
      getNoOfEmployee_onTodate(selectedBranch);
    }
  }, [selectedBranch, startDateFromRange, endDateFromRange]);

  const NoOfLeaveCountBydateandCountLate = async (
    startDate,
    endDate,
    branchName
  ) => {
    try {
      setLoading(true);
      await countLateAttendence_and_Leaves(
        startDate,
        endDate,
        branchName
      );
      setLoading(false);


      // const lateAttendanceCount = await getLateAttendence(
      //   startDate,
      //   endDate,
      //   branchName
      // );
      // console.log(lateAttendanceCount, "LATE Count");
      // setCountLate(lateAttendanceCount.data.total);
    }


    catch (error) {
      console.log(error.message);
    }
  };

  const getNoOfEmployee_onTodate = async (brnachName) => {
    try {
      console.log("Fetching ACTIVE employees for branch:", brnachName);
      // Don't pass dates - we want all active employees for the branch, not filtered by creation date
      const countResponse = await getNoOfEmployee(
        brnachName,
        null,
        null
      );
      console.log("Employee count API response:", countResponse);
      console.log("Number of active employees:", countResponse?.data?.length);
      console.log("Employee data:", countResponse?.data);

      if (countResponse?.data && Array.isArray(countResponse.data)) {
        setNoOfEmployee(countResponse.data);
        console.log("Set noOfEmployee to array with length:", countResponse.data.length);
      } else {
        console.warn("Invalid response format:", countResponse);
        setNoOfEmployee([]);
      }
    } catch (error) {
      console.error("Error fetching employee count:", error);
      setNoOfEmployee([]);
    }
  };

  const handleSelectChangeBranch = (selectedOption) => {
    console.log("===== MANUAL BRANCH SELECTION =====");
    console.log("Selected branch value:", selectedOption);
    console.log("Type:", typeof selectedOption);
    console.log("====================================");
    setNoOfEmployee([]);
    setCountLate(0);
    setAttendanceCount(0);
    setTodayLeaveCount(0);
    setTodayAttendanceCount(0);
    setSelectedBranch(selectedOption);

    getNoOfEmployee_onTodate(selectedOption);
    NoOfLeaveCountBydateandCountLate(
      startDateFromRange,
      endDateFromRange,
      selectedOption
    );
    fetchTodayData(selectedOption);
    fetchTodayLeaveCount(selectedOption);
    fetchTodayAttendanceCount(selectedOption);

    fetchAttendanceCount(selectedOption, startDateFromRange, endDateFromRange);
  };
  const attendanceChartConfig = {
    series: [todayLeaveCount, countLate],
    options: {
      chart: {
        type: "donut",
      },
      colors: ["#008FFB", "#00E396"],
      labels: ["Leave Count", "Late Count"],
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  };

  const attendanceWeeklyChart = {
    series: [
      {
        name: "Last Week",
        data: [31, 40, 28, 51, 42, 109, 100],
      },
      {
        name: "This Week",
        data: [11, 32, 45, 32, 34, 52, 41],
      },
    ],
    options: {
      chart: {
        height: 200,
        type: "line",
        toolbar: {
          show: false,
        },
      },
      colors: ["#FF9800", "#2196F3"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      xaxis: {
        categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      },
      yaxis: {
        show: false,
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
      legend: {
        show: false,
      },
      grid: {
        show: false,
      },
    },
  };

  useEffect(() => { }, []);

  const [branchAttendanceData, setBranchAttendanceData] = useState([]);

  useEffect(() => {
    const fetchBranchAttendance = async () => {
      try {
        const startDate = dayjs().startOf("month").format("YYYY-MM-DD");
        const endDate = dayjs().endOf("month").format("YYYY-MM-DD");

        const response = await getMonthlyAttendanceByBranch(startDate, endDate);
        setBranchAttendanceData(response);
      } catch (error) {
        console.error("Error fetching branch attendance:", error);
      }
    };

    fetchBranchAttendance();
  }, []);

  // Handle chart bar click to navigate to employee grid
  const handleBranchChartClick = (event, chartContext, config) => {
    const branchIndex = config.dataPointIndex;
    if (branchIndex >= 0 && branchAttendanceData[branchIndex]) {
      const selectedBranchData = branchAttendanceData[branchIndex];
      const branchLabel = selectedBranchData.branch;

      console.log('Clicked branch:', branchLabel); // Debug log

      // Extract the location name without prefix for searching
      // OKIDS-Wattala -> Wattala, OKIT-Wattala -> Wattala, OKI-Wattala -> Wattala
      let locationName = branchLabel;
      if (branchLabel.includes('-')) {
        locationName = branchLabel.split('-').pop().trim();
      }

      // Extract center from branch label
      let center = 'OKI'; // Default
      const upperLabel = branchLabel.toUpperCase();

      if (upperLabel.startsWith('OKIDS')) {
        center = 'OKIDS';
      } else if (upperLabel.startsWith('OKIT')) {
        center = 'OKIT';
      }

      console.log('Navigation data:', { branchLabel, locationName, center }); // Debug log

      // Navigate to employee grid with branch and center filter in state
      navigate('/employees-grid', {
        state: {
          filterBranch: { value: locationName, label: branchLabel },
          filterCenter: center,
          branchLabel: branchLabel,
          fromDashboard: true
        }
      });
    }
  };

  const branchHeadCountChart = {
    series: [
      {
        name: "Employees",
        data: branchAttendanceData.map((branch) => branch.count),
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 280,
        toolbar: { show: false },
        events: {
          dataPointSelection: handleBranchChartClick,
        },
        fontFamily: 'inherit',
        animations: {
          enabled: true,
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150
          }
        }
      },
      colors: ["#FFA500"],
      plotOptions: {
        bar: {
          borderRadius: 8,
          borderRadiusApplication: 'end',
          horizontal: false,
          columnWidth: "65%",
          distributed: false,
          dataLabels: {
            position: 'top',
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
        },
        offsetY: -25,
        style: {
          fontSize: '13px',
          fontWeight: '600',
          colors: ['#2c3e50']
        },
        background: {
          enabled: true,
          foreColor: '#FFA500',
          borderRadius: 4,
          padding: 4,
          opacity: 0.1,
          borderWidth: 0,
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: branchAttendanceData.map((branch) => branch.branch),
        labels: {
          style: {
            fontSize: "12px",
            fontWeight: 600,
            colors: '#4a5568'
          },
          rotate: -45,
          rotateAlways: true,
          offsetY: 5,
          trim: false,
        },
        axisBorder: {
          show: true,
          color: '#e2e8f0',
        },
        axisTicks: {
          show: true,
          color: '#e2e8f0',
        },
        tooltip: {
          enabled: false
        }
      },
      yaxis: {
        show: true,
        labels: {
          style: {
            fontSize: '12px',
            fontWeight: 500,
            colors: '#718096'
          },
          formatter: function (val) {
            return Math.floor(val);
          }
        },
        title: {
          text: 'Number of Employees',
          style: {
            fontSize: '13px',
            fontWeight: 600,
            color: '#4a5568'
          }
        }
      },
      grid: {
        show: true,
        borderColor: '#e2e8f0',
        strokeDashArray: 3,
        position: 'back',
        yaxis: {
          lines: {
            show: true
          }
        },
        xaxis: {
          lines: {
            show: false
          }
        },
        padding: {
          top: 0,
          right: 10,
          bottom: 0,
          left: 10
        }
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val, { dataPointIndex }) {
            const branch = branchAttendanceData[dataPointIndex]?.branch || '';
            return val + ' employees in ' + branch;
          },
          title: {
            formatter: function () {
              return 'Total';
            }
          }
        },
        custom: function ({ series, seriesIndex, dataPointIndex }) {
          const count = series[seriesIndex][dataPointIndex];
          const branch = branchAttendanceData[dataPointIndex]?.branch || '';
          return '<div class="custom-tooltip" style="padding: 8px 12px; background: #fff; border: 1px solid #e0e0e0; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">' +
            '<div style="font-weight: 600; color: #333; margin-bottom: 4px;">' + branch + '</div>' +
            '<div style="color: #FFA500; font-size: 18px; font-weight: bold;">' + count + ' <span style="font-size: 12px; color: #666;">employees</span></div>' +
            '<div style="margin-top: 6px; font-size: 11px; color: #999; font-style: italic;">Click to view details</div>' +
            '</div>';
        }
      },
      states: {
        hover: {
          filter: {
            type: 'darken',
            value: 0.15,
          }
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'darken',
            value: 0.3,
          }
        }
      },
      responsive: [{
        breakpoint: 768,
        options: {
          plotOptions: {
            bar: {
              columnWidth: '80%'
            }
          },
          dataLabels: {
            style: {
              fontSize: '11px'
            }
          }
        }
      }]
    },
  };

  const branchDistributionChart = {
    options: {
      chart: {
        type: "donut",
        height: 150,
      },
      colors: ["#2196F3", "#4CAF50", "#FF9800", "#E91E63"],
      labels: ["Wattala", "Negombo", "Kaduwela", "Kiribathgoda"],
      dataLabels: {
        style: {
          fontSize: "8px",
        },
      },
      legend: {
        show: false,
      },
    },
    series: [35, 25, 25, 15],
  };

  const attendanceFrequencyChart = {
    options: {
      chart: {
        type: "bar",
        height: 250,
        toolbar: {
          show: false,
        },
      },
      colors: ["#2196F3"],
      xaxis: {
        categories: ["Weekly", "Biweekly", "Semi", "Monthly", "Annually"],
        labels: {
          rotate: 0,
          style: {
            fontSize: "7px",
            fontFamily: "Arial, sans-serif",
          },
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          columnWidth: "50%",
        },
      },
    },
    series: [{ data: [44, 25, 41, 37, 22] }],
  };

  // const profileImageUrl = user?.profile_pic || ProPic;

  const [attendanceCount, setAttendanceCount] = useState(0);

  useEffect(() => {
    console.log("Attendance Count Updated:", attendanceCount);
  }, [attendanceCount]);

  const fetchAttendanceCount = async (branch, startDate, endDate) => {
    try {
      console.log("Fetching attendance for:", { branch, startDate, endDate });
      const response = await getAttendanceCountByBranchCount(
        startDate,
        endDate,
        branch
      );
      console.log("Attendance Count Response:", response);
      setAttendanceCount(response.total || 0);
    } catch (error) {
      console.error("Error fetching attendance count:", error);
    }
  };

  const fetchTodayLeaveCount = async (branch = null) => {
    try {
      const response = await getTodayLeaves(branch);
      setTodayLeaveCount(response.data?.length || 0);
    } catch (error) {
      console.error("Error fetching this month's leave count:", error);
      setTodayLeaveCount(0);
    }
  };

  const fetchTodayAttendanceCount = async (branch = null) => {
    try {
      const today = dayjs().format("YYYY-MM-DD");
      const response = await getAttendanceCountByBranchCount(
        today,
        today,
        branch
      );
      setTodayAttendanceCount(response.total || 0);
    } catch (error) {
      console.error("Error fetching today's attendance count:", error);
      setTodayAttendanceCount(0);
    }
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) {
      return "Good morning";
    } else if (hour < 17) {
      return "Good afternoon";
    } else {
      return "Good evening";
    }
  };

  const handleEmployeeCardClick = () => {
    navigate(all_routes.employeegrid, {
      state: {
        branch: selectedBranch,
        fromDashboard: true
      }
    });
  };

  const handleLeavesCardClick = () => {
    const today = dayjs().format("YYYY-MM-DD");
    navigate(all_routes.leavesadmin, {
      state: {
        branch: selectedBranch,
        startDate: today,
        endDate: today,
        fromDashboard: true
      }
    });
  };

  const handleAttendanceCardClick = () => {
    const today = dayjs().format("YYYY-MM-DD");
    navigate(all_routes.attendanceadmin, {
      state: {
        branch: selectedBranch,
        startDate: today,
        endDate: today,
        fromDashboard: true
      }
    });
  };

  return (
    <div className="adm_main_wrapper">
      <div className="adm_dash_wrapper">
        <div className="adm_content_container">
          <div className="adm_left_panel">
            <div className="adm_greeting_block">
              <div className="adm_greeting_text">
                <h1>
                  {getGreeting()} {userDetail?.name || userData?.data.name} !
                </h1>{" "}
                <p>happening with you today.</p>
              </div>
              <button
                className="adm_toggle_right_panel"
                onClick={toggleRightPanel}
                aria-label="Toggle right panel"
              >
                <Menu size={24} />
              </button>
            </div>

            <div className="adm_stat_tiles">
              <div
                className="adm_stat_tile adm_employees_tile"
                onClick={handleEmployeeCardClick}
                style={{ cursor: 'pointer' }}
              >
                <div className="adm_stat_icon">
                  <i className="fa-solid fa-users"></i>
                </div>

                <div className="adm_stat_details">
                  <h2 className="adm_stat_number">
                    <CountUp end={noOfEmployee?.length} duration={3}>
                      +
                    </CountUp>
                  </h2>
                  <p className="adm_stat_description">No of Employees</p>
                </div>
              </div>

              {role !== "Employee" ? (
                <div
                  className="adm_stat_tile adm_leaves_tile"
                  onClick={handleLeavesCardClick}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="adm_stat_icon">
                    <i className="fa-solid fa-calendar-days"></i>
                  </div>

                  <div className="adm_stat_details">
                    <h2 className="adm_stat_number">
                      <CountUp start={0} end={todayLeaveCount} duration={3} />
                    </h2>
                    <p className="adm_stat_description">No of Leaves (Today)</p>
                  </div>
                </div>
              ) : (
                ""
              )}

              {role !== "Employee" ? (
                <div
                  className="adm_stat_tile adm_attendance_tile"
                  onClick={handleAttendanceCardClick}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="adm_stat_icon">
                    <i className="fa-solid fa-user"></i>
                  </div>

                  <div className="adm_stat_details">
                    <h2 className="adm_stat_number">
                      <CountUp
                        end={todayAttendanceCount}
                        duration={3}
                      />
                    </h2>
                    <p className="adm_stat_description">Attendance (Today)</p>
                  </div>
                </div>
              ) : (
                ""
              )}

              {role !== "Employee" ? (
                <div className="adm_stat_tile adm_late_tile" style={{ display: "none" }}>
                  <div className="adm_stat_icon">
                    <i className="fa-solid fa-clock"></i>
                  </div>
                  <div className="adm_stat_details">
                    <h2 className="adm_stat_number adm_late_number">
                      <CountUp start={0} end={countLate} duration={3} />
                    </h2>
                    <p className="adm_stat_description">Late Attendance</p>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="adm_dashboard_grid">
              <div className="adm_today_tables_container">
                {/* Today's Birthdays Table */}
                <div className="adm_today_birthday_table_container">
                  <h3 className="adm_table_title">This Week Birthdays</h3>
                  <table className="adm_employee_table">
                    <thead>
                      <tr>
                        <th>Emp Name</th>
                        <th>Birthdate</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={2} className="adm_loading_cell">
                            Loading...
                          </td>
                        </tr>
                      ) : thisWeekBirthdays.length > 0 ? (
                        thisWeekBirthdays.map((employee, index) => (
                          <tr key={index}>
                            <td>{safeDisplayName(employee.name)}</td>
                            <td>
                              {employee.date_of_birth
                                ? dayjs(employee.date_of_birth).format("MMM DD")
                                : "-"}
                            </td>{" "}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={2} className="adm_empty_cell">
                            No birthdays this week
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="adm_today_tables_container">
                <div className="adm_today_leave_table_container">
                  <h3 className="adm_table_title">Today Leaves</h3>
                  <table className="adm_employee_table">
                    <thead>
                      <tr>
                        <th>Emp Name</th>
                        <th>EPF No.</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={2} className="adm_loading_cell">
                            Loading...
                          </td>
                        </tr>
                      ) : todayLeaves.length > 0 ? (
                        todayLeaves.map((employee, index) => (
                          <tr key={index}>
                            <td>{safeDisplayName(employee.name)}</td>
                            <td>{employee.epf_number || "-"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={2} className="adm_empty_cell">
                            No leaves today
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="adm_probation_end_table_container">
                <h3 className="adm_table_title">Probation Ending This Month</h3>
                <table className="adm_employee_table">
                  <thead>
                    <tr>
                      <th>Emp Name</th>
                      <th>Branch</th>
                      <th>Start</th>
                      <th>End</th>
                      <th>Category</th>
                      {/* <th>Status</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={6} className="adm_loading_cell">Loading...</td>
                      </tr>
                    ) : probationEndEmployees.length > 0 ? (
                      probationEndEmployees.map((employee, index) => (
                        <tr key={index}>
                          <td>{employee.full_name || "-"}</td>
                          <td>{employee.branch || "-"}</td>
                          <td>{employee.probation_start ? dayjs(employee.probation_start).format("MM-DD") : "-"}</td>
                          <td>{employee.probation_end ? dayjs(employee.probation_end).format("MM-DD") : "-"}</td>
                          <td>{employee.employee_category || "-"}</td>
                          {/* <td>{employee.status || "-"}</td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="adm_empty_cell">No employees with probation ending this month</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="adm_chart_box adm_attendance_donut_box">
                <h3 className="adm_table_title">This Month&apos;s Leave Employees</h3>

                <div className="adm_chart_container">
                  <div className="adm_donut_chart_container">
                    <ReactApexChart
                      options={attendanceChartConfig.options}
                      series={attendanceChartConfig.series}
                      type="donut"
                      height={300}
                    />
                    <div className="adm_chart_legend">
                      <div className="adm_legend_item">
                        <span className="adm_legend_dot adm_leave_dot"></span>
                        <span>
                          Leave Count {todayLeaveCount}
                        </span>
                      </div>
                      <div className="adm_legend_item">
                        <span className="adm_legend_dot adm_late_dot"></span>
                        <span>
                          Late Count {countLate}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="adm_employee_table_container">
                    <table className="adm_employee_table">
                      <thead>
                        <tr>
                          <th>Emp Name</th>
                          <th>Emp No</th>
                          <th>Branch</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={3} className="adm_loading_cell">
                              Loading...
                            </td>
                          </tr>
                        ) : todayLeaves.length > 0 ? (
                          todayLeaves.map((item) => (
                            <tr key={item._id}>
                              <td>{safeDisplayName(item.name)}</td>
                              <td>{item.epf_number || "-"}</td>
                              <td>{item.branch || "-"}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={3} className="adm_empty_cell">
                              No leaves this month
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="adm_chart_box adm_attendance_weekly_box">
                <h3 className="adm_chart_title">Attendance Weekly</h3>
                <div className="adm_chart_legend">
                  <div className="adm_legend_item">
                    <span className="adm_legend_dot adm_last_week_dot"></span>
                    <span>Last Week</span>
                  </div>
                  <div className="adm_legend_item">
                    <span className="adm_legend_dot adm_this_week_dot"></span>
                    <span>This Week</span>
                  </div>
                </div>
                <ReactApexChart
                  options={attendanceWeeklyChart.options}
                  series={attendanceWeeklyChart.series}
                  type="line"
                  height={200}
                />
              </div>

              <div className="adm_chart_box adm_branch_distribution_box" style={{ display: "none" }}>
                <div className="adm_branch_chart_wrapper">
                  <div className="adm_branch_donut_container">
                    <ReactApexChart
                      options={branchDistributionChart.options}
                      series={branchDistributionChart.series}
                      type="donut"
                      height={200}
                    />
                    <div className="adm_chart_legend">
                      <div className="adm_legend_item">
                        <span className="adm_legend_dot adm_wt_dot"></span>
                        <span>Wattala </span>
                      </div>
                      <div className="adm_legend_item">
                        <span className="adm_legend_dot adm_nb_dot"></span>
                        <span>Negombo </span>
                      </div>
                      <div className="adm_legend_item">
                        <span className="adm_legend_dot adm_kd_dot"></span>
                        <span>Kaduwela</span>
                      </div>
                      <div className="adm_legend_item">
                        <span className="adm_legend_dot adm_kb_dot"></span>
                        <span>Kiribathgoda </span>
                      </div>
                    </div>
                  </div>
                  <div className="adm_attendance_frequency_container">
                    <ReactApexChart
                      options={attendanceFrequencyChart.options}
                      series={attendanceFrequencyChart.series}
                      type="bar"
                      height={250}
                    />
                  </div>
                </div>
              </div>

              <div className="adm_chart_box adm_branch_head_count_box" style={{ cursor: 'default' }}>
                <h3 className="adm_chart_title">Employee Distribution</h3>
                <p style={{ fontSize: '12px', color: '#5e04f9ff', marginTop: '-8px', marginBottom: '14px', fontWeight: '500' }}>
                  Click on any column to view employee details
                </p>

                <div style={{ cursor: 'pointer' }}>
                  <ReactApexChart
                    options={branchHeadCountChart.options}
                    series={branchHeadCountChart.series}
                    type="bar"
                    height={280}
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className={`adm_right_panel ${rightPanelVisible ? "adm_right_panel_visible" : ""
              }`}
          >
            <div className="adm_right_panel_close">
              <button
                className="adm_close_right_panel"
                onClick={toggleRightPanel}
              >
                <i className="fa-solid fa-times"></i>
              </button>
            </div>
            <div className="adm_profile_container">
              <div className="adm_user_profile_box">
                {userDetail?.profilePic ? (
                  <img
                    src={`${base_path_img}${userDetail.profilePic}`}
                    alt="User profile"
                    className="adm_profile_avatar"
                  />
                ) : (
                  <img alt="User_profile" className="adm_profile_avatar" />
                )}

                <div className="adm_user_info_box">
                  <h3 className="adm_profile_h3"> {userDetail?.name || userData?.data.name} </h3>
                  <p className="adm_profile_p"> {currentTime}</p>
                </div>
              </div>
            </div>

            <div className="adm_sidebar_content">
              <div className="adm_calendar_container">
                <div className="adm_calendar_header">
                  <h3>{selectedMonth}</h3>
                  <div className="adm_calendar_navigation">
                    <button
                      className="adm_prev_month_btn"
                      onClick={handlePrevMonth}
                    >
                      <button
                        className="adm_prev_month_btn"
                        onClick={handleApply}
                      ></button>

                      <i className="fa-solid fa-chevron-left"></i>
                    </button>
                    <button
                      className="adm_next_month_btn"
                      onClick={handleNextMonth}
                    >
                      <i className="fa-solid fa-chevron-right"></i>
                    </button>
                  </div>
                </div>

                <div className="adm_calendar_weekdays">
                  {weekdays.map((day) => (
                    <div key={day} className="adm_weekday_label">
                      {day}
                    </div>
                  ))}
                </div>

                <div className="adm_calendar_days_grid">
                  {Array.from({ length: firstDayOfMonth }).map((_, index) => (
                    <div
                      key={`empty-${index}`}
                      className="adm_calendar_empty_day"
                    ></div>
                  ))}

                  {Array.from({ length: daysInMonth }, (_, i) => i + 1).map(
                    (day) => {
                      const isToday =
                        day === new Date().getDate() &&
                        currentDate.getMonth() === new Date().getMonth() &&
                        currentDate.getFullYear() === new Date().getFullYear();

                      return (
                        <div
                          key={day}
                          className={`adm_calendar_day ${isToday ? "adm_is_today" : ""
                            }`}
                        >
                          {day}
                        </div>
                      );
                    }
                  )}
                </div>
              </div>

              <div className="adm_branch_container">
                <h3>Branch</h3>
                <div className="adm_branch_selector_box">
                  <button className="adm_branch_select_btn">
                    <i className="fa-solid fa-building"></i>
                    <Select
                      value={branchOptions.value}
                      options={branchOptions}
                      className="select"
                      onChange={(selectedOption) =>
                        handleSelectChangeBranch(selectedOption)
                      }
                      style={{ width: "200%" }}
                      placeholder="Select branch"
                    />
                  </button>
                </div>
              </div>

              <div className="adm_reminders_container">
                <div className="adm_reminders_header">
                  <h3>Reminders</h3>
                  <button className="adm_add_reminder_btn">
                    <i className="fa-solid fa-plus"></i>
                  </button>
                </div>
                <div className="adm_todays_reminders">
                  <h4>Today</h4>
                  <div className="adm_reminder_item">
                    <div className="adm_reminder_icon adm_pay_date_icon">
                      <i className="fa-solid fa-calendar"></i>
                    </div>
                    <div className="adm_reminder_content">
                      <p>Next pay date</p>
                      <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
                        <p className="adm_reminder_date">
                          {nextPayDate}
                        </p>
                        {daysRemaining !== null && (
                          <div className="d-flex align-items-center">
                            <span className="adm_days_left_text">Days Left</span>
                            <span
                              className="adm_days_remaining_badge"
                              title={`${daysRemaining} days remaining`}
                            >
                              {daysRemaining}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="adm_reminder_item">
                    <div className="adm_reminder_icon adm_meeting_icon">
                      <i className="fa-solid fa-users"></i>
                    </div>
                    <div className="adm_reminder_content">
                      <p>InnovaCom meeting</p>
                      <p className="adm_reminder_time">4:00pm</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
